module.exports = __webpack_public_path__ + "static/media/AB_N1_19.54e4ba35.jpg";